import { ChangeDetectorRef, Component, ViewChild } from '@angular/core';
import { TdoTableV2Component } from '../../../../tdo-controls/common/tdo-table-v2/tdo-table-v2.component';
import { TdoTableSelectionEvent } from '../../../../tdo-controls/common/tdo-table-v2/models/tdo-table-selection.event';
import {
    cfgFormattedLabelModel,
    cfgFormattedLabelTokenModel,
    cfgLetterTokens,
    FormattedLabelUserModel
} from '../../../../models/labels/formattedLabelUser.model';
import { LabelService } from '../../../../services/label.service';
import { StaticDataService } from '../../../../services/static-data.service';
import { EnumValidValueItemModel } from '../../../../models/enum/enum-valid-value-item.model';
import { TdoTableRowModel } from '../../../../tdo-controls/common/tdo-table-v2/models/tdo-table-row.model';
import { DialogService } from '../../../../services/dialog.service';
import { Constants } from '../../../../constants';
import { MatCheckboxChange } from "@angular/material/checkbox";
import { FormattedLabelEnum } from 'src/app/models/enum/labels/formatted-label.enum';
import { UserService } from 'src/app/services/user.service';
import { TdoUserConfigurationModel } from 'src/app/models/configuration/user/tdo-user-configuration.model';
import { MatDialog } from '@angular/material/dialog';
import { ListNewFormattedLabelUsersComponent } from './list-new-formatted-label-users/list-new-formatted-label-users.component';
import { ToastrService } from 'ngx-toastr';

@Component({
    selector: 'app-formatting-label-configuration',
    templateUrl: './formatting-label-configuration.component.html',
    styleUrls: ['./formatting-label-configuration.component.scss']
})
export class FormattingLabelConfigurationComponent {
    @ViewChild('table') table: TdoTableV2Component;
    @ViewChild('formattedLabelsTable') formattedLabelsTable: TdoTableV2Component;

    isLoading = true;
    selectedEnumFormattedLabelID: FormattedLabelEnum.AppointmentLine1;
    labelUsers: FormattedLabelUserModel[] = [];
    newFormattedUserList: TdoUserConfigurationModel[] = [];
    selectedItem: FormattedLabelUserModel = new FormattedLabelUserModel();
    formattingLabel: EnumValidValueItemModel[] = [];
    FormattedLabelTokenList: cfgFormattedLabelTokenModel[] = [];
    filteredLabelTokenList: cfgFormattedLabelTokenModel[] = [];
    selectedFormattedLabelToken: cfgFormattedLabelTokenModel;
    LetterTokensList: cfgLetterTokens[] = [];
    enumFormattedLabelAppoitmentLine1 = FormattedLabelEnum.AppointmentLine1;
    currentLabelUserId: any = '';

    constructor(
        private readonly labelService: LabelService,
        private readonly staticDataService: StaticDataService,
        private readonly dialogService: DialogService,
        private readonly userService: UserService,
        private readonly dialog: MatDialog,
        private readonly changeDetectorRef: ChangeDetectorRef,
        private readonly toastr: ToastrService) {
    }


    async ngOnInit(): Promise<void> {
        this.labelUsers = await this.labelService.getFormattedLabelUsers().toPromise();
        this.newFormattedUserList = await this.userService.getFormattedLabelUser().toPromise();
        this.LetterTokensList = await this.labelService.getLetterTokenLabelsLabelUsers().toPromise();
        this.LetterTokensList.sort((a, b) => a.Description.localeCompare(b.Description));        
        console.log("ngoninit users:", this.labelUsers);
        console.log("ngoninit LetterTokensList:", this.LetterTokensList);
        this.selectedItem = this.labelUsers[0];
        this.FormattedLabelTokenList = await this.labelService.getFormattedLabelsByUserId(this.labelUsers[0].UserID).toPromise();
        this.isLoading = false;

        if (this.staticDataService.validValueItems && this.staticDataService.validValueItems.length > 0) {
            this.formattingLabel = this.staticDataService.getValidValueItemsByValidValueName('enumFormattedLabel');
        } else {
            this.staticDataService.validValuesReadyEvent.subscribe({
                complete: () => {
                    this.formattingLabel = this.staticDataService.getValidValueItemsByValidValueName('enumFormattedLabel');
                }
            });
        }

    }

    ngAfterViewInit(): void {
        const ivl = setInterval(() => {
            if (!this.formattedLabelsTable) {
                return;
            }
            clearInterval(ivl);
            this.changeFormattedLabel(this.selectedEnumFormattedLabelID);
            this.changeDetectorRef.detectChanges();
        }, 100);
    }


    onRowSelected(event: TdoTableSelectionEvent) {
        console.log("onRowSelected", event);
        if (event.model.FormattedLabelUserID === this.currentLabelUserId) {
            return;
        }
        this.currentLabelUserId = event.model.FormattedLabelUserID;
        this.selectedItem = event.model;
        this.selectedFormattedLabelToken = event.model;
        this.selectedEnumFormattedLabelID = this.enumFormattedLabelAppoitmentLine1 = FormattedLabelEnum.AppointmentLine1;
        this.labelService.getFormattedLabelsByUserId(this.selectedItem.FormattedLabelUserID).subscribe(labelsRes => {
            if (labelsRes) {
                this.FormattedLabelTokenList = labelsRes;
                this.filteredLabelTokenList = this.FormattedLabelTokenList.filter(x => x.enumFormattedLabelID === this.selectedEnumFormattedLabelID).sort(function (a, b) { return a.TokenOrder - b.TokenOrder; });
                this.formattedLabelsTable.updateData(this.filteredLabelTokenList);
                this.changeDetectorRef.detectChanges();
            }
        }
        );


    }

    onDeleteOtherService(row: TdoTableRowModel, event: MouseEvent) {
        event.stopImmediatePropagation();
        this.dialogService.openConfirmDialog('Are you sure you want to delete token?').subscribe((result) => {
            if (result === true) {
                const model = row.model;
                const idx = this.FormattedLabelTokenList.findIndex(p => p === model);
                if (idx > -1) {
                    this.FormattedLabelTokenList.splice(idx, 1);
                    this.filteredLabelTokenList = this.FormattedLabelTokenList.filter(x => x.enumFormattedLabelID === this.selectedEnumFormattedLabelID).sort(function (a, b) { return a.TokenOrder - b.TokenOrder; });
                    this.formattedLabelsTable.updateData(this.filteredLabelTokenList);
                    if (model.LabelFormatTokenID === Constants.emptyGuid || model.LabelFormatTokenID === undefined) {
                        return;
                    }
                    this.labelService.deleteFormattedLabelToken(model.LabelFormatTokenID).subscribe();
                }
            }
        });
    }

    onNewFormattedLabelTokens(event: any) {
        // open a window to select new user
        const labelUserIDs = this.labelUsers.map(p => p.UserID);

        const dialogRef = this.dialog.open(ListNewFormattedLabelUsersComponent, {
            panelClass: 'dialog',
            data: {
                ListFormattedUsers: this.newFormattedUserList.filter(p => !labelUserIDs.includes(p.UserID)),
            }
        });
        dialogRef.afterClosed().subscribe(async result => {
            if (result !== undefined && result !== false) {
                //create new formatted label user
                let data = await this.labelService.createFormattedLabelUsers(result.model.UserID).toPromise();// .subscribe(data => {
                if (data) {
                    this.labelUsers.push(data);
                    this.selectedItem = data;
                    this.table.updateData(this.labelUsers);

                }
            }
        });
    }

    saveFormattedLabels(event: any) {
        // save formatted labels;
    }

    changeFormattedLabel(event: any) {
        console.log("changeFormattedLabel", event);
        this.selectedEnumFormattedLabelID = event;
        const filteredTokens = this.FormattedLabelTokenList.filter(x => x.enumFormattedLabelID === this.selectedEnumFormattedLabelID);
        console.log("filteredTokens", filteredTokens);
        this.filteredLabelTokenList = filteredTokens.sort(function (a, b) { return a.TokenOrder - b.TokenOrder; });
        this.formattedLabelsTable.updateData(this.filteredLabelTokenList);
    }


    async saveFormattedLabelToken(row: TdoTableRowModel, formattedLabelToken: cfgFormattedLabelTokenModel, itemSaved: string = '') {
        console.log("saveFormattedLabelToken", row, formattedLabelToken, itemSaved);
        if (row.model.TokenID === '') { // only saved when selecting token
            return;
        }
        if (row.model.LabelFormatID === '' || row.model.LabelFormatID === undefined) {
            // create a new cfgFormattedLabel
            const newFormattedLabel = new cfgFormattedLabelModel();
            newFormattedLabel.enumFormattedLabelID = this.selectedEnumFormattedLabelID;
            newFormattedLabel.FormattedLabelUserId = this.selectedItem.FormattedLabelUserID;
            newFormattedLabel.LabelFormatID = Constants.emptyGuid;

            this.labelService.saveFormattedLabel(newFormattedLabel).subscribe(result => {
                if (result) {
                    formattedLabelToken.LabelFormatID = result.LabelFormatID;
                    this.labelService.saveFormattedLabelToken(formattedLabelToken).subscribe(data => {
                        this.showMessage('success', 'Label saved successfully');
                        this.selectedFormattedLabelToken = data;
                        const idx = this.FormattedLabelTokenList.findIndex(p => p.TokenID === data.TokenID || p.LabelFormatTokenID === data.LabelFormatTokenID);
                        this.FormattedLabelTokenList[idx] = data;
                        this.filteredLabelTokenList = this.FormattedLabelTokenList.filter(x => x.enumFormattedLabelID === this.selectedEnumFormattedLabelID).sort(function (a, b) { return a.TokenOrder - b.TokenOrder; });
                        this.formattedLabelsTable.updateData(this.filteredLabelTokenList);
                        this.changeDetectorRef.detectChanges();
                    });
                }
            });

        } else {
            if (itemSaved === 'Prefix') {
                row.model.Prefix = formattedLabelToken.Prefix === '' ? row.model.Prefix : formattedLabelToken.Prefix;
            } else if (itemSaved === 'Sufix') {
                row.model.Sufix = formattedLabelToken.Sufix === '' ? row.model.Sufix : formattedLabelToken.Sufix;
            } else if (itemSaved === 'enumFormattedLabel') {
                row.model.TokenID = formattedLabelToken.TokenID === '00000000-0000-0000-0000-000000000000' ? row.model.TokenID : formattedLabelToken.TokenID;
            } else if (itemSaved === 'isEndOfLine') {
                row.model.isEndOfLine = formattedLabelToken.isEndOfLine ?? row.model.isEndOfLine;
            } else if (itemSaved === 'tokenOrder') {
                row.model.TokenOrder = formattedLabelToken.TokenOrder ?? row.model.TokenOrder;
            }
            this.labelService.saveFormattedLabelToken(row.model).subscribe(data => {
                const idx = this.FormattedLabelTokenList.findIndex(p => p.LabelFormatTokenID === data.LabelFormatTokenID);
                const labelText = this.LetterTokensList.find(p => p.TokenID === data.TokenID).Description;
                this.showMessage('success', `Label ${labelText} saved successfully`);
                data.enumFormattedLabelID = this.selectedEnumFormattedLabelID;
                if (idx === -1) {
                    this.FormattedLabelTokenList.find(x => x.LabelFormatTokenID === "" && x.TokenOrder === data.TokenOrder).LabelFormatTokenID = data.LabelFormatTokenID;
                } else {
                    this.FormattedLabelTokenList[idx] = data;
                }
                const ivl = setInterval(() => {
                    if (!this.formattedLabelsTable) {
                        return;
                    }
                    clearInterval(ivl);
                    this.filteredLabelTokenList = this.FormattedLabelTokenList.filter(x => x.enumFormattedLabelID === this.selectedEnumFormattedLabelID).sort(function (a, b) { return a.TokenOrder - b.TokenOrder; });
                    this.formattedLabelsTable.updateData(this.filteredLabelTokenList);
                }, 10);
            });
        }
    }


    onFormattedLabelSelected(event: TdoTableSelectionEvent) {
        this.selectedFormattedLabelToken = event.model;
    }
    createNewLabel() {
        const newFormattedLabel = new cfgFormattedLabelTokenModel();
        newFormattedLabel.enumFormattedLabelID = this.selectedEnumFormattedLabelID;
        newFormattedLabel.LabelFormatID = this.formattedLabelsTable.dataSource.length >= 1 ? this.formattedLabelsTable.dataSource[0].LabelFormatID : "";
        newFormattedLabel.TokenOrder = this.formattedLabelsTable.dataSource.length + 1;
        this.FormattedLabelTokenList.push(newFormattedLabel);

        this.formattedLabelsTable.updateData(this.FormattedLabelTokenList.filter(x => x.enumFormattedLabelID === this.selectedEnumFormattedLabelID).sort(function (a, b) { return a.TokenOrder - b.TokenOrder; }));

    }

    onIsEndOfLine(row: TdoTableRowModel, event: MatCheckboxChange) {
        this.selectedFormattedLabelToken = row.model;
        this.selectedFormattedLabelToken.isEndOfLine = event.checked;
        this.saveFormattedLabelToken(row, this.selectedFormattedLabelToken, 'isEndOfLine');
    }

    showMessage(type, message) {
        if (type.toLowerCase() === "error")
            this.toastr.error(message, null, { timeOut: 7000 });
          else if (type.toLowerCase() === "warning")
            this.toastr.warning(message, null, { timeOut: 3000 });
          else
            this.toastr.success(message, null, { timeOut: 3000 });
        /*#focusOtherService
        this.snackBar.open(message, type, {
            duration: 3000,
            verticalPosition: 'top'
        });
        */
    }

    onLabelsReordered(event: void) {
        let i = 1;
        for (const item of this.formattedLabelsTable.matDataSource.data) {
            item.model.TokenOrder = i;
            i++;
        }
        for (const item of this.formattedLabelsTable.matDataSource.data) 
            this.saveFormattedLabelToken(item, this.selectedFormattedLabelToken, 'tokenOrder');
    }
}
